export const SET_DELETE     ="[Delete] Delete";

export const setDelete = (data) => ({
    type: SET_DELETE,
    payload: data
});